var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var globalSearch = function (React, ReactDOM, $, undefined) {

    function SearchType(index, availableComp) {
        this.index = index;
        this.displayName = availableComp.displayName;
        this.component = availableComp.component;
        this.checked = true;
    }

    function SearchModel(categories) {
        this.searchValue = "";
        this.categories = categories;
        this.result = {};
        this.currentPage = 0;
        this.itemsPerPage = 10;
    }

    function highlightSearchValue(item, searchString) {
        var firstPart = void 0;
        var highlightedPart = void 0;
        var endPart = void 0;

        if (item !== undefined && item.toString().toLowerCase().indexOf(searchString.toLowerCase()) !== -1) {
            var itemValue = item.toString();

            var startIndex = itemValue.toLowerCase().indexOf(searchString.toLowerCase());
            var endIndex = startIndex + searchString.length - 1;
            firstPart = itemValue.slice(0, startIndex);
            highlightedPart = itemValue.slice(startIndex, endIndex + 1);
            endPart = itemValue.slice(endIndex + 1);
        } else {
            firstPart = item;
            highlightedPart = "";
            endPart = "";
        }
        var values = {
            firstPart: firstPart,
            highlightedPart: highlightedPart,
            endPart: endPart
        };

        return React.createElement("div", { className: "result-text" }, values.firstPart, React.createElement("span", { className: "highlighted-text" }, values.highlightedPart), values.endPart);
    }

    var availableComponents = {
        "truck": { displayName: "Trucks", component: function component(model, searchString) {
                return React.createElement(TruckComponent, { model: model, param: searchString });
            } },
        "solution": { displayName: "Solution Tickets", component: function component(model, searchString) {
                return React.createElement(SolutionComponent, { model: model, param: searchString });
            } },
        "part": { displayName: "Parts", component: function component(model, searchString) {
                return React.createElement(PartComponent, { model: model, param: searchString });
            } },
        "warranty": { displayName: "Warranty Claims", component: function component(model, searchString) {
                return React.createElement(WarrantyComponent, { model: model, param: searchString });
            } },
        "customer": { displayName: "Customers", component: function component(model, searchString) {
                return React.createElement(CustomerComponent, { model: model, param: searchString });
            } },
        "page": { displayName: "Pages", component: function component(model, searchString) {
                return React.createElement(PageComponent, { model: model, param: searchString });
            } }
    };

    var ResultComponent = function (_React$Component) {
        _inherits(ResultComponent, _React$Component);

        function ResultComponent() {
            _classCallCheck(this, ResultComponent);

            return _possibleConstructorReturn(this, (ResultComponent.__proto__ || Object.getPrototypeOf(ResultComponent)).apply(this, arguments));
        }

        _createClass(ResultComponent, [{
            key: "viewType",
            value: function viewType() {
                var model = this.props.model;
                var searchString = this.props.param;
                var indexComponent = availableComponents[model.Index];
                if (indexComponent) return indexComponent.component(model, searchString);

                if (model.nodata) {
                    return "No Results";
                }

                return "Not Supported Result Type: " + model.Index;
            }
        }, {
            key: "render",
            value: function render() {
                return React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("div", { className: "panel panel-default" }, React.createElement("div", { className: "panel-body" }, this.viewType()))));
            }
        }]);

        return ResultComponent;
    }(React.Component);

    var PageComponent = function (_React$Component2) {
        _inherits(PageComponent, _React$Component2);

        function PageComponent() {
            _classCallCheck(this, PageComponent);

            return _possibleConstructorReturn(this, (PageComponent.__proto__ || Object.getPrototypeOf(PageComponent)).apply(this, arguments));
        }

        _createClass(PageComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var searchString = this.props.param;

                var parsedTitle = highlightSearchValue(model.title, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("div", { className: "title" }, "Title : ", React.createElement("b", null, " ", parsedTitle)), React.createElement("div", { className: "sub-title" }))));
            }
        }]);

        return PageComponent;
    }(React.Component);

    var TruckComponent = function (_React$Component3) {
        _inherits(TruckComponent, _React$Component3);

        function TruckComponent() {
            _classCallCheck(this, TruckComponent);

            return _possibleConstructorReturn(this, (TruckComponent.__proto__ || Object.getPrototypeOf(TruckComponent)).apply(this, arguments));
        }

        _createClass(TruckComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var searchString = this.props.param;
                var shipDate = "-";
                if (model.ShipDate) {
                    shipDate = moment(model.ShipDate.$date).format("MM/DD/YYYY");
                }

                var parsedVIN = highlightSearchValue(model.ShortVIN, searchString);
                var parsedCustomerName = highlightSearchValue(model.CustomerName, searchString);
                var parsedModelYear = highlightSearchValue(model.ModelYear, searchString);
                var parsedModel = highlightSearchValue(model.Model, searchString);
                var parsedTruckNumber = highlightSearchValue(model.TruckNumber, searchString);
                var parsedTicketsCount = highlightSearchValue(model.TicketsCount, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-8" }, React.createElement("div", { className: "title" }, "Truck VIN: ", React.createElement("b", null, " #", parsedVIN)), React.createElement("div", { className: "sub-title" }, "Site: ", parsedCustomerName)), React.createElement("div", { className: "text-right col-xs-4" }, React.createElement("div", { className: "btn-group" }, React.createElement("button", { className: "btn btn-gray dropdown-toggle", "data-toggle": "dropdown" }, React.createElement("b", null, "Action"), React.createElement("i", { className: "fa fa-angle-down" })), React.createElement("ul", { className: "dropdown-menu dropdown-menu-right" }, React.createElement("li", null, React.createElement("a", null, "View")), React.createElement("li", null, React.createElement("a", null, "Edit")))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Unit #")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Year")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Model")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Ship date")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Tickets"))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, parsedTruckNumber), React.createElement("div", { className: "col-xs-2" }, parsedModelYear), React.createElement("div", { className: "col-xs-2" }, parsedModel), React.createElement("div", { className: "col-xs-2" }, shipDate), React.createElement("div", { className: "col-xs-3" }, parsedTicketsCount)));
            }
        }]);

        return TruckComponent;
    }(React.Component);

    var SolutionComponent = function (_React$Component4) {
        _inherits(SolutionComponent, _React$Component4);

        function SolutionComponent() {
            _classCallCheck(this, SolutionComponent);

            return _possibleConstructorReturn(this, (SolutionComponent.__proto__ || Object.getPrototypeOf(SolutionComponent)).apply(this, arguments));
        }

        _createClass(SolutionComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var searchString = this.props.param;
                var openClosed = model.DateFinalized ? "Closed" : "Open";
                var openDate = moment(model.DateLogged.$date).format("MM/DD/YYYY");
                var closedDate = model.DateFinalized ? moment(model.DateFinalized.$date).format("MM/DD/YYYY") : null;

                var parsedTicketNumber = highlightSearchValue(model.TicketNumber, searchString);
                var parsedCustomerName = highlightSearchValue(model.CustomerName, searchString);
                var parsedProblemTypeDescription = highlightSearchValue(model.ProblemTypeDescription, searchString);
                var parsedTechnician = highlightSearchValue(model.Technician, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-8" }, React.createElement("div", { className: "title" }, "Solution Ticket: ", React.createElement("b", null, " #", parsedTicketNumber)), React.createElement("div", { className: "sub-title" }, "Site: ", parsedCustomerName)), React.createElement("div", { className: "text-right col-xs-4" }, React.createElement("div", { className: "btn-group" }, React.createElement("button", { className: "btn btn-gray dropdown-toggle", "data-toggle": "dropdown" }, React.createElement("b", null, "Action"), React.createElement("i", { className: "fa fa-angle-down" })), React.createElement("ul", { className: "dropdown-menu dropdown-menu-right" }, React.createElement("li", null, React.createElement("a", null, "View")), React.createElement("li", null, React.createElement("a", null, "Edit")))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Status")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Category")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Technician")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Open Date")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Close Date"))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, openClosed), React.createElement("div", { className: "col-xs-2" }, parsedProblemTypeDescription), React.createElement("div", { className: "col-xs-2" }, parsedTechnician), React.createElement("div", { className: "col-xs-2" }, openDate), React.createElement("div", { className: "col-xs-3" }, closedDate)));
            }
        }]);

        return SolutionComponent;
    }(React.Component);

    var PartComponent = function (_React$Component5) {
        _inherits(PartComponent, _React$Component5);

        function PartComponent() {
            _classCallCheck(this, PartComponent);

            return _possibleConstructorReturn(this, (PartComponent.__proto__ || Object.getPrototypeOf(PartComponent)).apply(this, arguments));
        }

        _createClass(PartComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var searchString = this.props.param;

                var parsedPartNumber = highlightSearchValue(model.PartNumber, searchString);
                var parsedPartDescription = highlightSearchValue(model.PartDescription, searchString);
                var parsedPartId = highlightSearchValue(model.PartId, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-8" }, React.createElement("div", { className: "title" }, "Part Id: ", React.createElement("b", null, " #", parsedPartId)), React.createElement("div", { className: "sub-title" }, "Supplier: -")), React.createElement("div", { className: "text-right col-xs-4" }, React.createElement("div", { className: "btn-group" }, React.createElement("button", { className: "btn btn-gray dropdown-toggle", "data-toggle": "dropdown" }, React.createElement("b", null, "Action"), React.createElement("i", { className: "fa fa-angle-down" })), React.createElement("ul", { className: "dropdown-menu dropdown-menu-right" }, React.createElement("li", null, React.createElement("a", null, "View")), React.createElement("li", null, React.createElement("a", null, "Edit")))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Description")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Supplier Part #")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Qty/Truck")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Unit Price"))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, parsedPartDescription), React.createElement("div", { className: "col-xs-3" }, parsedPartNumber), React.createElement("div", { className: "col-xs-3" }, "-"), React.createElement("div", { className: "col-xs-2" }, "-")));
            }
        }]);

        return PartComponent;
    }(React.Component);

    var WarrantyComponent = function (_React$Component6) {
        _inherits(WarrantyComponent, _React$Component6);

        function WarrantyComponent() {
            _classCallCheck(this, WarrantyComponent);

            return _possibleConstructorReturn(this, (WarrantyComponent.__proto__ || Object.getPrototypeOf(WarrantyComponent)).apply(this, arguments));
        }

        _createClass(WarrantyComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var statusDate = moment(model.StatusDate).format("MM/DD/YYYY");
                var searchString = this.props.param;

                var parsedClaimNumber = highlightSearchValue(model.WarrantyClaimNumber, searchString);
                var parsedCustomerName = highlightSearchValue(model.CustomerName, searchString);
                var parsedClaimStatusDescription = highlightSearchValue(model.ClaimStatusDescription, searchString);
                var parsedClaimTypeDescription = highlightSearchValue(model.ClaimTypeDescription, searchString);
                var parsedClaimTotal = highlightSearchValue(model.ClaimTotal, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-8" }, React.createElement("div", { className: "title" }, "Warranty Claim: ", React.createElement("b", null, " #", parsedClaimNumber)), React.createElement("div", { className: "sub-title" }, "Site: ", parsedCustomerName)), React.createElement("div", { className: "text-right col-xs-4" }, React.createElement("div", { className: "btn-group" }, React.createElement("button", { className: "btn btn-gray dropdown-toggle", "data-toggle": "dropdown" }, React.createElement("b", null, "Action"), React.createElement("i", { className: "fa fa-angle-down" })), React.createElement("ul", { className: "dropdown-menu dropdown-menu-right" }, React.createElement("li", null, React.createElement("a", null, "View")), React.createElement("li", null, React.createElement("a", null, "Edit")))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Status")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Unit #")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Claim Type")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Status Date")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Claim Total"))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, parsedClaimStatusDescription), React.createElement("div", { className: "col-xs-2" }, "-"), React.createElement("div", { className: "col-xs-2" }, parsedClaimTypeDescription), React.createElement("div", { className: "col-xs-2" }, statusDate), React.createElement("div", { className: "col-xs-3" }, parsedClaimTotal)));
            }
        }]);

        return WarrantyComponent;
    }(React.Component);

    var CustomerComponent = function (_React$Component7) {
        _inherits(CustomerComponent, _React$Component7);

        function CustomerComponent() {
            _classCallCheck(this, CustomerComponent);

            return _possibleConstructorReturn(this, (CustomerComponent.__proto__ || Object.getPrototypeOf(CustomerComponent)).apply(this, arguments));
        }

        _createClass(CustomerComponent, [{
            key: "render",
            value: function render() {
                var model = this.props.model.Source;
                var searchString = this.props.param;

                var parsedCustomerId = highlightSearchValue(model.CustomerId, searchString);
                var parsedCustomerName = highlightSearchValue(model.Name, searchString);
                var parsedCity = highlightSearchValue(model.City, searchString);
                var parsedZIPCode = highlightSearchValue(model.ZIPCode, searchString);
                var parsedAddress1 = highlightSearchValue(model.Address1, searchString);

                return React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-8" }, React.createElement("div", { className: "title" }, "Customer: ", React.createElement("b", null, " #", parsedCustomerId)), React.createElement("div", { className: "sub-title" }, "Site: ", parsedCustomerName)), React.createElement("div", { className: "text-right col-xs-4" }, React.createElement("div", { className: "btn-group" }, React.createElement("button", { className: "btn btn-gray dropdown-toggle", "data-toggle": "dropdown" }, React.createElement("b", null, "Action"), React.createElement("i", { className: "fa fa-angle-down" })), React.createElement("ul", { className: "dropdown-menu dropdown-menu-right" }, React.createElement("li", null, React.createElement("a", null, "View")), React.createElement("li", null, React.createElement("a", null, "Edit")))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Id #")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "Name")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "City")), React.createElement("div", { className: "col-xs-2" }, React.createElement("b", null, "ZIP Code")), React.createElement("div", { className: "col-xs-3" }, React.createElement("b", null, "Address1"))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-3" }, parsedCustomerId), React.createElement("div", { className: "col-xs-2" }, parsedCustomerName), React.createElement("div", { className: "col-xs-2" }, parsedCity), React.createElement("div", { className: "col-xs-2" }, parsedZIPCode), React.createElement("div", { className: "col-xs-3" }, parsedAddress1)));
            }
        }]);

        return CustomerComponent;
    }(React.Component);

    var SearchComponent = function (_React$Component8) {
        _inherits(SearchComponent, _React$Component8);

        function SearchComponent() {
            _classCallCheck(this, SearchComponent);

            var _this8 = _possibleConstructorReturn(this, (SearchComponent.__proto__ || Object.getPrototypeOf(SearchComponent)).call(this));

            var categories = _.map(availableComponents, function (item, index) {
                return new SearchType(index, item);
            });
            _this8.state = new SearchModel(categories);
            return _this8;
        }

        // after render


        _createClass(SearchComponent, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                $("#atac_app-global-search-modal").on("shown.bs.modal", function () {
                    $("#atac_app-global-search-modal form input").focus();
                });
            }

            // distroy

        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {}
        }, {
            key: "handleSearch",
            value: function handleSearch(e) {
                e.preventDefault();
                this.setState({ currentPage: 0 }, this.searchExecute);
            }
        }, {
            key: "searchExecute",
            value: function searchExecute() {
                var self = this;
                var searchValue = ReactDOM.findDOMNode(this.refs.searchInput).value;
                var categories = this.state.categories.filter(function (item) {
                    return item.checked;
                }).map(function (item) {
                    return item.index;
                });

                ATAC.showLoader();
                $.ajax({
                    url: window.portal_api_url + "/api/ElasticSearch",
                    data: {
                        q: searchValue,
                        st: categories,
                        skip: this.state.currentPage * this.state.itemsPerPage,
                        take: this.state.itemsPerPage
                    },
                    success: function success(data) {
                        self.setState({ result: data });
                    },
                    error: function error(xhr, status, err) {
                        self.setState({ result: [] });
                    },
                    complete: function complete() {
                        self.setState({ searchValue: searchValue });
                        ATAC.hideLoader();
                    }
                });
            }
        }, {
            key: "handleChangeCheckbox",
            value: function handleChangeCheckbox(e) {
                var categories = this.state.categories.slice();
                categories.find(function (item) {
                    if (item.index === e.target.value) {
                        item.checked = !item.checked;
                    }
                });
                this.setState({ categories: categories });
            }
        }, {
            key: "changePage",
            value: function changePage(e, addPages) {
                e.preventDefault();
                var totalPages = Math.ceil(this.state.result.Total / this.state.itemsPerPage);
                var newPage = this.state.currentPage + addPages;
                if (newPage > -1 && newPage < totalPages) {
                    this.setState({ currentPage: newPage }, this.searchExecute);
                }
            }
        }, {
            key: "onPageInputChange",
            value: function onPageInputChange(e) {
                e.preventDefault();
                var page = parseInt(e.target.value);
                if (isNaN(page)) {
                    return;
                }

                var diff = page - 1 - this.state.currentPage;
                if (diff === 0) {
                    return;
                }
                this.changePage(e, diff);
            }
        }, {
            key: "render",
            value: function render() {
                var _this9 = this;

                var self = this;

                var indexes = this.state.categories.map(function (item) {
                    return React.createElement("li", { className: "" + (item.checked ? "completed" : "active"), onClick: function onClick(item) {
                            if (item.checked) {
                                item.checked = false;
                            } else {
                                item.checked = true;
                            }
                        } }, React.createElement("label", null, React.createElement("input", { type: "checkbox", checked: item.checked, value: item.index,
                        onChange: self.handleChangeCheckbox.bind(self), hidden: true }), React.createElement("a", null, item.displayName)));
                });

                var result = void 0;
                var resultCount = 0;
                var totalResultCount = 0;
                var displayedItemFirstIndex = 0;
                var displayedItemLastIndex = 0;

                var currentPage = this.state.currentPage;
                var totalPages = 0;
                var searchString = void 0;

                if (!this.state.result || !this.state.result.Hits || this.state.result.Hits.length === 0) {
                    result = React.createElement(ResultComponent, { model: { nodata: true } });
                } else {
                    //resultCount = this.state.result.Hits.length;
                    totalResultCount = this.state.result.Total;
                    totalPages = Math.ceil(totalResultCount / this.state.itemsPerPage);
                    searchString = ReactDOM.findDOMNode(this.refs.searchInput).value;

                    displayedItemFirstIndex = this.state.itemsPerPage * currentPage + 1;
                    displayedItemLastIndex = displayedItemFirstIndex + this.state.itemsPerPage - 1;
                    if (displayedItemLastIndex > totalResultCount) displayedItemLastIndex = totalResultCount;

                    result = React.createElement("div", null, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-md-12" }, React.createElement("ul", { className: "pagination" }, React.createElement("li", { className: currentPage === 0 ? 'disabled' : null, onClick: function onClick(e) {
                            return _this9.changePage(e, -1);
                        }, title: "Previous page" }, React.createElement("a", null, "<")), React.createElement("li", null, React.createElement("a", null, React.createElement("input", { type: "number", value: currentPage + 1, onChange: function onChange(e) {
                            return _this9.onPageInputChange(e);
                        } }))), React.createElement("li", { className: currentPage === totalPages - 1 ? 'disabled' : null, onClick: function onClick(e) {
                            return _this9.changePage(e, 1);
                        }, title: "Next page" }, React.createElement("a", null, ">"))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, "Showing ", displayedItemFirstIndex, " to ", displayedItemLastIndex, " of ", totalResultCount, " Results For ", React.createElement("i", null, "'", this.state.searchValue, "'"))), this.state.result.Hits.map(function (item) {
                        return React.createElement(ResultComponent, { model: item, param: searchString });
                    }));
                }

                return React.createElement("div", { id: "atac_app-nav-search" }, React.createElement("div", { className: "theme-back-green" }, React.createElement("i", { className: "fa fa-search", "data-toggle": "modal", "data-target": "#atac_app-global-search-modal" })), React.createElement("div", { className: "modal fade", "data-backdrop": "static", id: "atac_app-global-search-modal", tabindex: "-1", role: "dialog", "aria-": true,
                    labelledby: "myModalLabel" }, React.createElement("div", { className: "modal-dialog", role: "document" }, React.createElement("div", { className: "modal-content" }, React.createElement("div", { className: "modal-header" }, React.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close" }, React.createElement("span", { "aria-hidden": "true" }, "x")), React.createElement("h4", { className: "modal-title", id: "myModalLabel" }, "Global Search")), React.createElement("div", { className: "modal-body" }, React.createElement("div", { className: "container-fluent" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("form", { className: "form-horizontal", onSubmit: this.handleSearch.bind(this) }, React.createElement("div", { className: "search-control" }, React.createElement("input", { type: "text", className: "form-control", placeholder: "Search", ref: "searchInput", tabindex: "0" }), React.createElement("button", { className: "input-group-addon theme-back-green fa fa-search search-btn" }))))), React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("ul", { className: "nav nav-stacked nav-stacked-wizard" }, indexes))), result)), React.createElement("div", { className: "modal-footer" }, React.createElement("button", { type: "button", className: "btn btn-default", "data-dismiss": "modal" }, "Close"))))));
            }
        }]);

        return SearchComponent;
    }(React.Component);

    return {
        render: function render() {
            var el = document.getElementById("atac_global_search");
            if (el) {
                ReactDOM.render(React.createElement(SearchComponent, null), el);
            }
        }
    };
}(React, ReactDOM, jQuery);
//# sourceMappingURL=global_search.js.map
